"use strict";

exports.__esModule = true;
exports.DashboardToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _System = require("../../../System");
var _Device = require("../../Device");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _DashboardFilter = require("./DashboardFilter");
var _PlantTwinFilter = require("../../Filters/PlantTwinFilter");
var _DeviceTypeFilter = require("../../Filters/DeviceTypeFilter");
var _DeviceTagFilter = require("../../Filters/DeviceTagFilter");
var _PlantStateActivities = require("../../PlantStateActivities");
var _AiEditButton = require("../../AI/Authoring/AiEditButton");
var _dec, _dec2, _dec3, _class, _DashboardToolbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Toolbar for specific dashboards.
 */
var DashboardToolbar = exports.DashboardToolbar = (_dec = _PlantStateActivitiesContext.PlantStateActivitiesContext.withContext, _dec2 = _URLFilter.URLFilterContext.withContext, _dec3 = _Device.DeviceTagListContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_DashboardToolbar = /*#__PURE__*/function (_Component) {
  function DashboardToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DashboardToolbar, _Component);
  var _proto = DashboardToolbar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      dashboard = _this$props.dashboard,
      deviceTags = _this$props.deviceTags,
      devices = _this$props.devices,
      urlFilter = _this$props.urlFilter,
      allPlantStateActivities = _this$props.plantStateActivities;
    var filters = urlFilter.filters,
      setFilter = urlFilter.setFilter;
    var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
    var selectedStates = plantStateActivities.states.filter(function (state) {
      return filters.states ? filters.states.includes(state.id) : [];
    });
    var renderDeviceSelector = function renderDeviceSelector() {
      return /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
        permission: "PLANT_TWIN"
      }, function (_ref) {
        var isAllowed = _ref.isAllowed;
        if (isAllowed) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PlantTwinFilter.PlantTwinFilter, {
            property: "devices"
          }), /*#__PURE__*/_react["default"].createElement(_DeviceTagFilter.DeviceTagFilter, null), /*#__PURE__*/_react["default"].createElement(_DeviceTypeFilter.DeviceTypeFilter, null));
        }
        return /*#__PURE__*/_react["default"].createElement(_Device.MultiDeviceSelector, {
          style: {
            maxWidth: 200,
            marginRight: 16
          },
          devices: devices,
          tags: deviceTags,
          selectAllByDefault: true,
          selected: filters.devices,
          onSelect: function onSelect(devices) {
            return setFilter("devices", devices.map(function (device) {
              return device.uuid;
            }));
          }
        });
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, {
      "data-testid": "DashboardToolbar"
    }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true
    }, renderDeviceSelector(), /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodSelector, {
      value: filters.period,
      onChange: function onChange(period) {
        return setFilter("period", period);
      }
    })), /*#__PURE__*/_react["default"].createElement(_DashboardFilter.FilterButton, {
      items: plantStateActivities.states,
      selected: selectedStates,
      onSelectFilter: function onSelectFilter(states) {
        setFilter("states", states.map(function (state) {
          return state.id;
        }));
      }
    }), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      permission: "EDIT_DASHBOARDS"
    }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      style: {
        marginLeft: "auto"
      },
      to: (0, _System.getScreenURL)("UpdateDashboard", dashboard, (0, _System.compactQuery)(filters)),
      icon: _icons.IconNames.EDIT,
      minimal: true,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DashboardToolbar.updateDashboardButton.text",
        defaultMessage: "Edit Dashboard"
      })
    })), /*#__PURE__*/_react["default"].createElement(_AiEditButton.AiEditButton, {
      kind: "dashboard",
      document: dashboard,
      onReload: this.props.onReload
    }));
  };
  return DashboardToolbar;
}(_react.Component), _DashboardToolbar.defaultProps = {
  urlFilter: undefined,
  deviceTags: undefined,
  plantStateActivities: undefined
}, _DashboardToolbar)) || _class) || _class) || _class);